// Mock API - Demo data cho testing
export const mockApi = {
  // Mock data cho sảnh PG (data thật từ API)
  tableListData: {
    PG: [
            {
                "name": "Cuộc Đối Đầu Tiền Thưởng Hoang Dã",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0113.png",
                "vassalage": "PG",
                "id": 1
            },
            {
                "name": "Đường Mạt Chược 2",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0055.png",
                "vassalage": "PG",
                "id": 2
            },
            {
                "name": "Đường Mạt Chược 1",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0046.png",
                "vassalage": "PG",
                "id": 3
            },
            {
                "name": "Kho Báu AZTEC",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0066.png",
                "vassalage": "PG",
                "id": 4
            },
            {
                "name": "Neko may mắn",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0073.png",
                "vassalage": "PG",
                "id": 5
            },
            {
                "name": "Thỏ May Mắn",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0120.png",
                "vassalage": "PG",
                "id": 6
            },
            {
                "name": "Kỳ Lân Mách Nước",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0084.png",
                "vassalage": "PG",
                "id": 7
            },
            {
                "name": "Ban nhạc hoang dã",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0083.png",
                "vassalage": "PG",
                "id": 8
            },
            {
                "name": "Đêm tiệc cocktail",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0098.png",
                "vassalage": "PG",
                "id": 9
            },
            {
                "name": "Chiến Thắng Thần Tài",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0052.png",
                "vassalage": "PG",
                "id": 10
            },
            {
                "name": "thần may mắn ganesha",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0057.png",
                "vassalage": "PG",
                "id": 11
            },
            {
                "name": "Rồng May Mắn",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0140.png",
                "vassalage": "PG",
                "id": 12
            },
            {
                "name": "pháo hoa hoang dã",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0063.png",
                "vassalage": "PG",
                "id": 13
            },
            {
                "name": "Nữ hoàng tiền thưởng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0071.png",
                "vassalage": "PG",
                "id": 14
            },
            {
                "name": "Truyền thuyết về Perseus",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0111.png",
                "vassalage": "PG",
                "id": 15
            },
            {
                "name": "Khỉ Hoang Dã#3258",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0143.png",
                "vassalage": "PG",
                "id": 16
            },
            {
                "name": "khủng hoảng zombie",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0148.png",
                "vassalage": "PG",
                "id": 17
            },
            {
                "name": "Asgardian trỗi dậy",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0118.png",
                "vassalage": "PG",
                "id": 18
            },
            {
                "name": "Sự Báo Thù Của Geisha",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0158.png",
                "vassalage": "PG",
                "id": 19
            },
            {
                "name": "Anubis",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0146.png",
                "vassalage": "PG",
                "id": 20
            },
            {
                "name": "Cơn cuồng tiền mặt",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0142.png",
                "vassalage": "PG",
                "id": 21
            },
            {
                "name": "Danh dự Yakuza",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0151.png",
                "vassalage": "PG",
                "id": 22
            },
            {
                "name": "Tiền thưởng cá mập",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0150.png",
                "vassalage": "PG",
                "id": 23
            },
            {
                "name": "Truyền thuyết Người sói",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0138.png",
                "vassalage": "PG",
                "id": 24
            },
            {
                "name": "yêu tinh giàu có",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0041.png",
                "vassalage": "PG",
                "id": 25
            },
            {
                "name": "Cơn sốt bữa tiệc cuồng nhiệt",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0121.png",
                "vassalage": "PG",
                "id": 26
            },
            {
                "name": "Giấc mơ Ma Cao",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0060.png",
                "vassalage": "PG",
                "id": 27
            },
            {
                "name": "Kho Báu Của Thuyền Trưởng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0039.png",
                "vassalage": "PG",
                "id": 28
            },
            {
                "name": "Nhà Vô Địch Tốc Độ",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0110.png",
                "vassalage": "PG",
                "id": 29
            },
            {
                "name": "Chim cánh cụt",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0037.png",
                "vassalage": "PG",
                "id": 30
            },
            {
                "name": "Đôi cánh của Iguazu",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0152.png",
                "vassalage": "PG",
                "id": 31
            },
            {
                "name": "Tài sản của Midas",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0119.png",
                "vassalage": "PG",
                "id": 32
            },
            {
                "name": "Pinata Wins",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0144.png",
                "vassalage": "PG",
                "id": 33
            },
            {
                "name": "Tiền Thưởng Grimms: Hansel & Gretel",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0170.png",
                "vassalage": "PG",
                "id": 34
            },
            {
                "name": "Thợ Mỏ Ngân Hà",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0169.png",
                "vassalage": "PG",
                "id": 35
            },
            {
                "name": "Cuộc Truy Tìm Kho Báu Rồng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0168.png",
                "vassalage": "PG",
                "id": 36
            },
            {
                "name": "Cơn Sốt Quán Ăn Vòng Quay",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0167.png",
                "vassalage": "PG",
                "id": 37
            },
            {
                "name": "Jack Thợ Săn Người Khổng Lồ",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0166.png",
                "vassalage": "PG",
                "id": 38
            },
            {
                "name": "Kho báu của người chết",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0165.png",
                "vassalage": "PG",
                "id": 39
            },
            {
                "name": "Cú Đấm Giàu Sang",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0164.png",
                "vassalage": "PG",
                "id": 40
            },
            {
                "name": "Cơn Cuồng Nộ Tận Thế",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0163.png",
                "vassalage": "PG",
                "id": 41
            },
            {
                "name": "Cuộc Đua Graffiti",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0163.png",
                "vassalage": "PG",
                "id": 42
            },
            {
                "name": "Vận May Của Ngài Kho Báu",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0161.png",
                "vassalage": "PG",
                "id": 43
            },
            {
                "name": "Kỳ quan Inca",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0160.png",
                "vassalage": "PG",
                "id": 44
            },
            {
                "name": "Rắn May Mắn",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0159.png",
                "vassalage": "PG",
                "id": 45
            },
            {
                "name": "Sô-cô-la Cao Cấp",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0157.png",
                "vassalage": "PG",
                "id": 46
            },
            {
                "name": "Lễ hội Rio",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0156.png",
                "vassalage": "PG",
                "id": 47
            },
            {
                "name": "Kỳ Quan Viện Bảo Tàng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0155.png",
                "vassalage": "PG",
                "id": 48
            },
            {
                "name": "Niềm vui ẩm thực Oishi",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0154.png",
                "vassalage": "PG",
                "id": 49
            },
            {
                "name": "Ba chú heo điên",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0153.png",
                "vassalage": "PG",
                "id": 50
            },
            {
                "name": "Bóng đá nóng bỏng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0149.png",
                "vassalage": "PG",
                "id": 51
            },
            {
                "name": "Chicky Chạy",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0147.png",
                "vassalage": "PG",
                "id": 52
            },
            {
                "name": "Phép thuật huyền bí",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0145.png",
                "vassalage": "PG",
                "id": 53
            },
            {
                "name": "Đá quý vàng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0141.png",
                "vassalage": "PG",
                "id": 54
            },
            {
                "name": "Rồng Lửa 2",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0139.png",
                "vassalage": "PG",
                "id": 55
            },
            {
                "name": "Báu vật của Tsar (Báu vật của Tsar)",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0137.png",
                "vassalage": "PG",
                "id": 56
            },
            {
                "name": "Băng Nhóm Mafia",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0136.png",
                "vassalage": "PG",
                "id": 57
            },
            {
                "name": "Lò Vàng (Lò Vàng)",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0135.png",
                "vassalage": "PG",
                "id": 58
            },
            {
                "name": "Rút tiền trong vụ cướp hoang dã",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0134.png",
                "vassalage": "PG",
                "id": 59
            },
            {
                "name": "Tiền đạo tối thượng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0133.png",
                "vassalage": "PG",
                "id": 60
            },
            {
                "name": "Cuồng nhiệt Hải Tặc Ninja",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0132.png",
                "vassalage": "PG",
                "id": 61
            },
            {
                "name": "VinhquangcủaNgườiđấusĩ",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0131.png",
                "vassalage": "PG",
                "id": 62
            },
            {
                "name": "Safari Hoang Dã",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0130.png",
                "vassalage": "PG",
                "id": 63
            },
            {
                "name": "Du thuyền Hoàng gia",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0129.png",
                "vassalage": "PG",
                "id": 64
            },
            {
                "name": "Kẹo Trái Cây",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0128.png",
                "vassalage": "PG",
                "id": 65
            },
            {
                "name": "Cỏ Ba Lá May Mắn Giàu Có",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/VI/PG0127.png",
                "vassalage": "PG",
                "id": 66
            },
            {
                "name": "Siêu Golf Drive",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0126.png",
                "vassalage": "PG",
                "id": 67
            },
            {
                "name": "Linh hồn huyền bí",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0125.png",
                "vassalage": "PG",
                "id": 68
            },
            {
                "name": "Lễ té nước Songkran",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0124.png",
                "vassalage": "PG",
                "id": 69
            },
            {
                "name": "Tiệm bánh Bonanza",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0123.png",
                "vassalage": "PG",
                "id": 70
            },
            {
                "name": "tiki hawaii",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0122.png",
                "vassalage": "PG",
                "id": 71
            },
            {
                "name": "Bữa Tối Hân Hoan",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0117.png",
                "vassalage": "PG",
                "id": 72
            },
            {
                "name": "Vàng giả kim",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0116.png",
                "vassalage": "PG",
                "id": 73
            },
            {
                "name": "Kỳ quan vật tổ",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0115.png",
                "vassalage": "PG",
                "id": 74
            },
            {
                "name": "Cây Tài Lộc Thịnh Vượng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0114.png",
                "vassalage": "PG",
                "id": 75
            },
            {
                "name": "Wild Coaster",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0112.png",
                "vassalage": "PG",
                "id": 76
            },
            {
                "name": "Heo đất may mắn",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0109.png",
                "vassalage": "PG",
                "id": 77
            },
            {
                "name": "Win Win Fish Prawn Crab",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0108.png",
                "vassalage": "PG",
                "id": 78
            },
            {
                "name": "Battleground Royale",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0107.png",
                "vassalage": "PG",
                "id": 79
            },
            {
                "name": "Bữa tiệc của Nữ hoàng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0106.png",
                "vassalage": "PG",
                "id": 80
            },
            {
                "name": "Rooster Rumble",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0105.png",
                "vassalage": "PG",
                "id": 81
            },
            {
                "name": "Hoa bướm",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0104.png",
                "vassalage": "PG",
                "id": 82
            },
            {
                "name": "Destiny of Sun & Moon",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0103.png",
                "vassalage": "PG",
                "id": 83
            },
            {
                "name": "Đá quý Garuda",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0102.png",
                "vassalage": "PG",
                "id": 84
            },
            {
                "name": "Hổ vận may",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0101.png",
                "vassalage": "PG",
                "id": 85
            },
            {
                "name": "Sự thịnh vượng phương Đông",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0100.png",
                "vassalage": "PG",
                "id": 86
            },
            {
                "name": "Lễ hội hóa trang",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0099.png",
                "vassalage": "PG",
                "id": 87
            },
            {
                "name": "Biểu tượng cảm xúc phong phú",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0097.png",
                "vassalage": "PG",
                "id": 88
            },
            {
                "name": "Kỳ quan vùng đất linh hồn",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0095.png",
                "vassalage": "PG",
                "id": 89
            },
            {
                "name": "Vua khỉ huyền thoại",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0094.png",
                "vassalage": "PG",
                "id": 90
            },
            {
                "name": "Buffalo Win",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0093.png",
                "vassalage": "PG",
                "id": 91
            },
            {
                "name": "Siêu thị Spree",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0092.png",
                "vassalage": "PG",
                "id": 92
            },
            {
                "name": "Raider Jane's Crypt of Fortune",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0091.png",
                "vassalage": "PG",
                "id": 93
            },
            {
                "name": "Mermaid Riches",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0089.png",
                "vassalage": "PG",
                "id": 94
            },
            {
                "name": "Vương quốc kỷ Jura",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0088.png",
                "vassalage": "PG",
                "id": 95
            },
            {
                "name": "Sự trỗi dậy của Apollo",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0086.png",
                "vassalage": "PG",
                "id": 96
            },
            {
                "name": "Heist of Stakes",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0085.png",
                "vassalage": "PG",
                "id": 97
            },
            {
                "name": "Kẹo Bonanza",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0082.png",
                "vassalage": "PG",
                "id": 98
            },
            {
                "name": "Kho báu hùng vĩ",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0081.png",
                "vassalage": "PG",
                "id": 99
            },
            {
                "name": "Vàng tiền điện tử",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0080.png",
                "vassalage": "PG",
                "id": 100
            },
            {
                "name": "Kỳ nghỉ Bali",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0079.png",
                "vassalage": "PG",
                "id": 101
            },
            {
                "name": "Vận may tuổi Sửu",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0078.png",
                "vassalage": "PG",
                "id": 102
            },
            {
                "name": "Vương triều Opera",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0077.png",
                "vassalage": "PG",
                "id": 103
            },
            {
                "name": "Người bảo vệ băng và lửa",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0076.png",
                "vassalage": "PG",
                "id": 104
            },
            {
                "name": "Đá quý thiên hà",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0075.png",
                "vassalage": "PG",
                "id": 105
            },
            {
                "name": "Jack Sương Giá Mùa Đông",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0074.png",
                "vassalage": "PG",
                "id": 106
            },
            {
                "name": "Trang sức của sự thịnh vượng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0072.png",
                "vassalage": "PG",
                "id": 107
            },
            {
                "name": "Sự quyến rũ của ma cà rồng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0070.png",
                "vassalage": "PG",
                "id": 108
            },
            {
                "name": "Bí Mật Của Cleopatra",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0069.png",
                "vassalage": "PG",
                "id": 109
            },
            {
                "name": "Kỳ quan sông Thái",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0068.png",
                "vassalage": "PG",
                "id": 110
            },
            {
                "name": "Circus Delight",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0067.png",
                "vassalage": "PG",
                "id": 111
            },
            {
                "name": "Đèn Aladdin",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0065.png",
                "vassalage": "PG",
                "id": 112
            },
            {
                "name": "Phượng Hoàng Nổi Dậy",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0059.png",
                "vassalage": "PG",
                "id": 113
            },
            {
                "name": "Cuốn sách bí ẩn của Ai Cập",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0056.png",
                "vassalage": "PG",
                "id": 114
            },
            {
                "name": "Thiên Đường Bikini",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0054.png",
                "vassalage": "PG",
                "id": 115
            },
            {
                "name": "nổ kẹo",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0053.png",
                "vassalage": "PG",
                "id": 116
            },
            {
                "name": "Vị Cứu Tinh - Hành Trình",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0051.png",
                "vassalage": "PG",
                "id": 117
            },
            {
                "name": "Bóng Đá Thiếu Lâm",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0050.png",
                "vassalage": "PG",
                "id": 118
            },
            {
                "name": "Guồng Quay Tình Yêu",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0049.png",
                "vassalage": "PG",
                "id": 119
            },
            {
                "name": "chuột may mắn",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0048.png",
                "vassalage": "PG",
                "id": 120
            },
            {
                "name": "Long Sinh",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0047.png",
                "vassalage": "PG",
                "id": 121
            },
            {
                "name": "Rồng Hổ May Mắn",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0045.png",
                "vassalage": "PG",
                "id": 122
            },
            {
                "name": "Nhà Vô Địch Muay Thái",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0044.png",
                "vassalage": "PG",
                "id": 123
            },
            {
                "name": "Ninja đối đầu Samurai",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0043.png",
                "vassalage": "PG",
                "id": 124
            },
            {
                "name": "Bá Hổ Thu Hương",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0042.png",
                "vassalage": "PG",
                "id": 125
            },
            {
                "name": "Cuộc Phiêu Lưu Đến Kho Báu",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0038.png",
                "vassalage": "PG",
                "id": 126
            },
            {
                "name": "Kho Báu Khổng Lồ",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0035.png",
                "vassalage": "PG",
                "id": 127
            },
            {
                "name": "Khu Rừng Vui Nhộn",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0033.png",
                "vassalage": "PG",
                "id": 128
            },
            {
                "name": "Ganesha Vàng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0031.png",
                "vassalage": "PG",
                "id": 129
            },
            {
                "name": "Ân Sủng Của Hoàng Đế",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0030.png",
                "vassalage": "PG",
                "id": 130
            },
            {
                "name": "Biểu Tượng Ai Cập",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0029.png",
                "vassalage": "PG",
                "id": 131
            },
            {
                "name": "Heo Vàng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0028.png",
                "vassalage": "PG",
                "id": 132
            },
            {
                "name": "Vị Cứu Tinh - Thanh Kiếm",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0027.png",
                "vassalage": "PG",
                "id": 133
            },
            {
                "name": "Quà Của Ông Già Noel",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0025.png",
                "vassalage": "PG",
                "id": 134
            },
            {
                "name": "Gấu Trúc Hip Hop",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0024.png",
                "vassalage": "PG",
                "id": 135
            },
            {
                "name": "Sư Tử Vương Giả",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0023.png",
                "vassalage": "PG",
                "id": 136
            },
            {
                "name": "Huyền thoại Hou Yi",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0021.png",
                "vassalage": "PG",
                "id": 137
            },
            {
                "name": "Ông Hallow-Win!",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0020.png",
                "vassalage": "PG",
                "id": 138
            },
            {
                "name": "Truyền Thuyết Rồng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0019.png",
                "vassalage": "PG",
                "id": 139
            },
            {
                "name": "Cô Bé Quàng Khăn Đỏ",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0017.png",
                "vassalage": "PG",
                "id": 140
            },
            {
                "name": "Vị Cứu Tinh",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0014.png",
                "vassalage": "PG",
                "id": 141
            },
            {
                "name": "Plushie Frenzy",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0012.png",
                "vassalage": "PG",
                "id": 142
            },
            {
                "name": "Medusa 1: Lời nguyền của Athena",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0009.png",
                "vassalage": "PG",
                "id": 143
            },
            {
                "name": "Cây Tài Lộc",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0007.png",
                "vassalage": "PG",
                "id": 144
            },
            {
                "name": "Medusa 2: Sứ mệnh Perseus",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0005.png",
                "vassalage": "PG",
                "id": 145
            },
            {
                "name": "Win Win Won",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0004.png",
                "vassalage": "PG",
                "id": 146
            },
            {
                "name": "Thần May Mắn",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0003.png",
                "vassalage": "PG",
                "id": 147
            },
            {
                "name": "Mỹ Nhân Kế Của Diao Chan",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PG/EN/PG0002.png",
                "vassalage": "PG",
                "id": 148
            }
        ],
    BNG: [
            {
                "name": "Aztec Fire-Hold & Win",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG047.png",
                "id": 173846,
                "vassalage": "BNG"
            },
            {
                "name": "Magic Apple",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG021.png",
                "id": 173709,
                "vassalage": "BNG"
            },
            {
                "name": "Tiger Jungle",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG013.png",
                "id": 173701,
                "vassalage": "BNG"
            },
            {
                "name": "Mặt trời của Ai Cập 3",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG006.png",
                "id": 173694,
                "vassalage": "BNG"
            },
            {
                "name": "Black Wolf",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG051.png",
                "id": 173850,
                "vassalage": "BNG"
            },
            {
                "name": "Đạt vàng!",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG019.png",
                "id": 173707,
                "vassalage": "BNG"
            },
            {
                "name": "Xu LÊN: Tia chớp",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG093.png",
                "id": 186017,
                "vassalage": "BNG"
            },
            {
                "name": "15 viên ngọc rồng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG029.png",
                "id": 173717,
                "vassalage": "BNG"
            },
            {
                "name": "Sói Đen 2",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG073.png",
                "id": 179520,
                "vassalage": "BNG"
            },
            {
                "name": "Lượt nhiều vàng hơn",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG057.png",
                "id": 174882,
                "vassalage": "BNG"
            },
            {
                "name": "đèn ma thuật latinh",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG090.png",
                "id": 184909,
                "vassalage": "BNG"
            },
            {
                "name": "Bọ hung pha lê",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG080.png",
                "id": 180390,
                "vassalage": "BNG"
            },
            {
                "name": "3 chậu cỏ ba lá",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG088.png",
                "id": 182935,
                "vassalage": "BNG"
            },
            {
                "name": "Tinh Thần Châu Phi Sticky Wilds",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG076.png",
                "id": 180168,
                "vassalage": "BNG"
            },
            {
                "name": "Mặt Trời Ai Cập 4 (Mặt Trời Ai Cập 4)",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG083.png",
                "id": 181174,
                "vassalage": "BNG"
            },
            {
                "name": "Nữ hoàng của mặt trời",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG008.png",
                "id": 173696,
                "vassalage": "BNG"
            },
            {
                "name": "Sư tử múa vàng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG009.png",
                "id": 173697,
                "vassalage": "BNG"
            },
            {
                "name": "3 xu: Ai Cập",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG016.png",
                "id": 173704,
                "vassalage": "BNG"
            },
            {
                "name": "Vụ Cướp Lớn",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG102.png",
                "id": 187290,
                "vassalage": "BNG"
            },
            {
                "name": "Kẹo bùng nổ",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG010.png",
                "id": 173698,
                "vassalage": "BNG"
            },
            {
                "name": "Bùa hoa sen",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG002.png",
                "id": 173690,
                "vassalage": "BNG"
            },
            {
                "name": "3 Ớt Siêu Cay: Giữ Vững Chiến Thắng",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG160.png",
                "id": 194093,
                "vassalage": "BNG"
            },
            {
                "name": "777 Đồng Xu",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG074.png",
                "id": 179728,
                "vassalage": "BNG"
            },
            {
                "name": "3 Núi Lửa Xu",
                "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/BNG/EN/BNG107.png",
                "id": 188412,
                "vassalage": "BNG"
            }
        ],
    CQ9:[
        {
            "id": 10551,
            "name": "Tốt Tạp Chí Vận May M",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0194.png",
            "vassalage": "CQ9"
        },
        {
            "id": 10466,
            "name": "Sàn Nhảy Đêm M",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0188.png",
            "vassalage": "CQ9"
        },
        {
            "id": 168331,
            "name": "Cây Tiền",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0344.png",
            "vassalage": "CQ9"
        },
        {
            "id": 7773,
            "name": "Trái Tim Rồng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/VI/CQ0097.png",
            "vassalage": "CQ9"
        },
        {
            "id": 133322,
            "name": "Pháp Cao Thần 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0262.png",
            "vassalage": "CQ9"
        },
        {
            "id": 7548,
            "name": "Nhảy Cao",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0049.png",
            "vassalage": "CQ9"
        },
        {
            "id": 172170,
            "name": "K.O. hòn đảo",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0403.png",
            "vassalage": "CQ9"
        },
        {
            "id": 170470,
            "name": "Đèn của Aladdin",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0384.png",
            "vassalage": "CQ9"
        },
        {
            "id": 167063,
            "name": "Nữ Hoàng Lửa2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0322.png",
            "vassalage": "CQ9"
        },
        {
            "id": 148952,
            "name": "Nhảy Cao 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0296.png",
            "vassalage": "CQ9"
        },
        {
            "id": 171803,
            "name": "Cua Tôm Cá Thái",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0399.png",
            "vassalage": "CQ9"
        },
        {
            "id": 134389,
            "name": "Hercules",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0267.png",
            "vassalage": "CQ9"
        },
        {
            "id": 10382,
            "name": "Bay Ra Khỏi",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0173.png",
            "vassalage": "CQ9"
        },
        {
            "id": 10683,
            "name": "Vịnh Cai Thần",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0206.png",
            "vassalage": "CQ9"
        },
        {
            "id": 169918,
            "name": "Vua của Atlantis",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0378.png",
            "vassalage": "CQ9"
        },
        {
            "id": 10340,
            "name": "Điện Thoại Di Động Nhảy Cao Hơn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0165.png",
            "vassalage": "CQ9"
        },
        {
            "id": 8624,
            "name": "Thần May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0105.png",
            "vassalage": "CQ9"
        },
        {
            "id": 11781,
            "name": "5 Đức Chúa Trời Quái Thú",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0218.png",
            "vassalage": "CQ9"
        },
        {
            "id": 7546,
            "name": "Vận May Lành",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/VI/CQ0047.png",
            "vassalage": "CQ9"
        },
        {
            "id": 169919,
            "name": "Xoc Dia",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0379.png",
            "vassalage": "CQ9"
        },
        {
            "id": 8769,
            "name": "Chúc May Mắn Hàng Năm",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0111.png",
            "vassalage": "CQ9"
        },
        {
            "id": 10550,
            "name": "Pháp Cai Thần M",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0193.png",
            "vassalage": "CQ9"
        },
        {
            "id": 10176,
            "name": "Điện Thoại Di Động",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0155.png",
            "vassalage": "CQ9"
        },
        {
            "id": 169825,
            "name": "HILO Thái Lan",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0375.png",
            "vassalage": "CQ9"
        },
        {
            "id": 9516,
            "name": "Thần Zeus",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0120.png",
            "vassalage": "CQ9"
        },
        {
            "id": 9587,
            "name": "Sàn Nhảy Đêm",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0139.png",
            "vassalage": "CQ9"
        },
        {
            "id": 194168,
            "name": "Điên Điên",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0500.png",
            "vassalage": "CQ9"
        },
        {
            "id": 194167,
            "name": "Bậc Thầy Watah Siêu Tốc",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0499.png",
            "vassalage": "CQ9"
        },
        {
            "id": 194166,
            "name": "Át Chủ Bài Siêu Cấp",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0498.png",
            "vassalage": "CQ9"
        },
        {
            "id": 194165,
            "name": "Điên Điên 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0497.png",
            "vassalage": "CQ9"
        },
        {
            "id": 194164,
            "name": "Pin Sạc Dự Phòng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0496.png",
            "vassalage": "CQ9"
        },
        {
            "id": 194163,
            "name": "Điên Điên 3",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0495.png",
            "vassalage": "CQ9"
        },
        {
            "id": 194162,
            "name": "Mạt Chược Mở Bài 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0494.png",
            "vassalage": "CQ9"
        },
        {
            "id": 194161,
            "name": "Heo Nhảy Disco",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0493.png",
            "vassalage": "CQ9"
        },
        {
            "id": 194160,
            "name": "Mạt Chược Hoang Dã",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0492.png",
            "vassalage": "CQ9"
        },
        {
            "id": 194158,
            "name": "Bậc Thầy Watah",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0490.png",
            "vassalage": "CQ9"
        },
        {
            "id": 193827,
            "name": "Mạt Chược Phát Tài",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0489.png",
            "vassalage": "CQ9"
        },
        {
            "id": 193086,
            "name": "Đêm Disco Cuồng Nhiệt",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0467.png",
            "vassalage": "CQ9"
        },
        {
            "id": 193085,
            "name": "Ngộ Không Đen",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0466.png",
            "vassalage": "CQ9"
        },
        {
            "id": 188364,
            "name": "Câu Cá",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/VI/CQ0438.png",
            "vassalage": "CQ9"
        },
        {
            "id": 178350,
            "name": "Chicago II",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0432.png",
            "vassalage": "CQ9"
        },
        {
            "id": 178066,
            "name": "Xã hội đen",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0431.png",
            "vassalage": "CQ9"
        },
        {
            "id": 177170,
            "name": "Cướp kho báu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0429.png",
            "vassalage": "CQ9"
        },
        {
            "id": 175830,
            "name": "Bingo sôi nổi",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0424.png",
            "vassalage": "CQ9"
        },
        {
            "id": 175412,
            "name": "Tam quốc anh hùng - Tào Tháo",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/CQ9/EN/CQ0423.png",
            "vassalage": "CQ9"
        }
    ],
    EVOPLAY:[
        {
            "id": 187452,
            "name": "Đá Phạt: Đường Phố",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0039.png",
            "vassalage": "EP"
        },
        {
            "id": 187417,
            "name": "Bóng Rổ Chớp Nhoáng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0004.png",
            "vassalage": "EP"
        },
        {
            "id": 187446,
            "name": "Quán Pub Tháng Mười",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0033.png",
            "vassalage": "EP"
        },
        {
            "id": 187451,
            "name": "Đá Phạt",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0038.png",
            "vassalage": "EP"
        },
        {
            "id": 187465,
            "name": "Thimbles",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0052.png",
            "vassalage": "EP"
        },
        {
            "id": 187461,
            "name": "Thầy Phù Thủy Bí Ngô",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0048.png",
            "vassalage": "EP"
        },
        {
            "id": 187424,
            "name": "Người Chuyển Phát",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0011.png",
            "vassalage": "EP"
        },
        {
            "id": 187435,
            "name": "Bắn Khúc Côn Cầu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0022.png",
            "vassalage": "EP"
        },
        {
            "id": 187432,
            "name": "Goblin Chạy",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0019.png",
            "vassalage": "EP"
        },
        {
            "id": 187450,
            "name": "Loạt Đá Phạt",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0037.png",
            "vassalage": "EP"
        },
        {
            "id": 187462,
            "name": "Cứu Chú Chuột",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0049.png",
            "vassalage": "EP"
        },
        {
            "id": 187416,
            "name": "Ngục Tối Bất Tử Ác Quỷ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0003.png",
            "vassalage": "EP"
        },
        {
            "id": 187425,
            "name": "Lâu Đài Bị Nguyền Rủa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0012.png",
            "vassalage": "EP"
        },
        {
            "id": 193666,
            "name": "Gã Hề Lửa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0229.png",
            "vassalage": "EP"
        },
        {
            "id": 187641,
            "name": "Bài Hát Của Sói Non",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0228.png",
            "vassalage": "EP"
        },
        {
            "id": 187640,
            "name": "X-Demon Mua Tiền Thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0227.png",
            "vassalage": "EP"
        },
        {
            "id": 187639,
            "name": "X-Demon",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0226.png",
            "vassalage": "EP"
        },
        {
            "id": 187638,
            "name": "Trang Trại Kỳ Diệu Mua Tiền Thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0225.png",
            "vassalage": "EP"
        },
        {
            "id": 187637,
            "name": "Trang Trại Kỳ Diệu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0224.png",
            "vassalage": "EP"
        },
        {
            "id": 187636,
            "name": "Sói Ẩn Nấp Mua Tiền Thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0223.png",
            "vassalage": "EP"
        },
        {
            "id": 187635,
            "name": "Sói Ẩn Nấp",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0222.png",
            "vassalage": "EP"
        },
        {
            "id": 187634,
            "name": "Ngôi Sao Mùa Đông Mua Tiền Thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0221.png",
            "vassalage": "EP"
        },
        {
            "id": 187633,
            "name": "Ngôi Sao Mùa Đông",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0220.png",
            "vassalage": "EP"
        },
        {
            "id": 187632,
            "name": "Quản Thủ Hoang Dã Mua",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0219.png",
            "vassalage": "EP"
        },
        {
            "id": 187631,
            "name": "Quản Thủ Hoang Dã",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0218.png",
            "vassalage": "EP"
        },
        {
            "id": 187630,
            "name": "Đạn Hoang",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0217.png",
            "vassalage": "EP"
        },
        {
            "id": 187628,
            "name": "Lễ Hội Venice",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0215.png",
            "vassalage": "EP"
        },
        {
            "id": 187627,
            "name": "Đêm Vegas",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0214.png",
            "vassalage": "EP"
        },
        {
            "id": 187626,
            "name": "Thung Lũng Giấc Mơ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0213.png",
            "vassalage": "EP"
        },
        {
            "id": 187625,
            "name": "Điều Ước Vô Hạn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0212.png",
            "vassalage": "EP"
        },
        {
            "id": 187624,
            "name": "Kho Báu Vô Hạn Mua Tiền Thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0211.png",
            "vassalage": "EP"
        },
        {
            "id": 187623,
            "name": "Kho Báu Vô Hạn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0210.png",
            "vassalage": "EP"
        },
        {
            "id": 187622,
            "name": "Ba Ớt",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0209.png",
            "vassalage": "EP"
        },
        {
            "id": 187619,
            "name": "Cây Ánh Sáng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0206.png",
            "vassalage": "EP"
        },
        {
            "id": 187618,
            "name": "Săn Kho Báu: Mua Tiền Thưởng Giáng Sinh",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0205.png",
            "vassalage": "EP"
        },
        {
            "id": 187617,
            "name": "Săn Kho Báu Mua Tiền Thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0204.png",
            "vassalage": "EP"
        },
        {
            "id": 187616,
            "name": "Săn Kho Báu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0203.png",
            "vassalage": "EP"
        },
        {
            "id": 187615,
            "name": "Mania Kho Báu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0202.png",
            "vassalage": "EP"
        },
        {
            "id": 187614,
            "name": "Bảy Sấm Sét Mua Tiền Thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0201.png",
            "vassalage": "EP"
        },
        {
            "id": 187613,
            "name": "Bảy Sấm Sét",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0200.png",
            "vassalage": "EP"
        },
        {
            "id": 187612,
            "name": "Người Slav",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0199.png",
            "vassalage": "EP"
        },
        {
            "id": 187611,
            "name": "Cú Đánh Lớn Nhất Mua Tiền Thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0198.png",
            "vassalage": "EP"
        },
        {
            "id": 187610,
            "name": "Cú Đánh Lớn Nhất",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0197.png",
            "vassalage": "EP"
        },
        {
            "id": 187608,
            "name": "Lăng Mộ Hoàng Đế",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0195.png",
            "vassalage": "EP"
        },
        {
            "id": 187607,
            "name": "Dây Đai của Nhà Vô Địch Mua Tiền Thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0194.png",
            "vassalage": "EP"
        },
        {
            "id": 187606,
            "name": "Dây Đai của Nhà Vô Địch",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0193.png",
            "vassalage": "EP"
        },
        {
            "id": 187605,
            "name": "Đền Thờ Sấm Sét II",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0192.png",
            "vassalage": "EP"
        },
        {
            "id": 187604,
            "name": "Đền Thờ Sấm Sét",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0191.png",
            "vassalage": "EP"
        },
        {
            "id": 187603,
            "name": "Đền Thờ Người Chết Mua Tiền Thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0190.png",
            "vassalage": "EP"
        },
        {
            "id": 187602,
            "name": "Đền Thờ Người Chết",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0189.png",
            "vassalage": "EP"
        },
        {
            "id": 187601,
            "name": "Bùa May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0188.png",
            "vassalage": "EP"
        },
        {
            "id": 187600,
            "name": "Đường Ngọt Ngào",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0187.png",
            "vassalage": "EP"
        },
        {
            "id": 187599,
            "name": "Vùng Lướt Sóng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0186.png",
            "vassalage": "EP"
        },
        {
            "id": 187598,
            "name": "Bán Nó Mua Tiền Thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0185.png",
            "vassalage": "EP"
        },
        {
            "id": 187597,
            "name": "Bán Nó",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0184.png",
            "vassalage": "EP"
        },
        {
            "id": 187596,
            "name": "Bóng Tối của Luxor",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0183.png",
            "vassalage": "EP"
        },
        {
            "id": 187594,
            "name": "Chữ Rune của Định Mệnh",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0181.png",
            "vassalage": "EP"
        },
        {
            "id": 187593,
            "name": "Quy Tắc La Mã",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0180.png",
            "vassalage": "EP"
        },
        {
            "id": 187592,
            "name": "Ngôi Sao Tên Lửa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0179.png",
            "vassalage": "EP"
        },
        {
            "id": 187591,
            "name": "Robin Hood",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0178.png",
            "vassalage": "EP"
        },
        {
            "id": 187590,
            "name": "Sự Trỗi Dậy của Horus",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0177.png",
            "vassalage": "EP"
        },
        {
            "id": 187589,
            "name": "Cuộn Giàu Có",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0176.png",
            "vassalage": "EP"
        },
        {
            "id": 187588,
            "name": "Vương Quốc Rồng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0175.png",
            "vassalage": "EP"
        },
        {
            "id": 187584,
            "name": "Chuyện Chồn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0171.png",
            "vassalage": "EP"
        },
        {
            "id": 187583,
            "name": "Bắt Cá Đại Dương Mua Tiền Thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0170.png",
            "vassalage": "EP"
        },
        {
            "id": 187581,
            "name": "Thế Giới Hạt Nhân",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/EP/EN/EP0168.png",
            "vassalage": "EP"
        }
    ],
    FASHPIN:[
        {
            "id": 188832,
            "name": "Công Chúa Mạt Chược",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/VI/FS0047.png",
            "vassalage": "FS"
        },
        {
            "id": 189085,
            "name": "Tây Du Ký",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/VI/FS0048.png",
            "vassalage": "FS"
        },
        {
            "id": 182543,
            "name": "Cao Bồi Bóng Đêm",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0033.png",
            "vassalage": "FS"
        },
        {
            "id": 182552,
            "name": "Chiến Thắng Sóng Nước",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0042.png",
            "vassalage": "FS"
        },
        {
            "id": 192681,
            "name": "Mafia hoang dã",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/VI/FS0051.png",
            "vassalage": "FS"
        },
        {
            "id": 182554,
            "name": "Rồng Vàng Thần Tài",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0044.png",
            "vassalage": "FS"
        },
        {
            "id": 182550,
            "name": "Tiki Vội Vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0040.png",
            "vassalage": "FS"
        },
        {
            "id": 182536,
            "name": "Neko Phú Quý",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0026.png",
            "vassalage": "FS"
        },
        {
            "id": 182541,
            "name": "Katt Hoàng Gia",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0031.png",
            "vassalage": "FS"
        },
        {
            "id": 182549,
            "name": "Búp Bê Nutcracker",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0039.png",
            "vassalage": "FS"
        },
        {
            "id": 182542,
            "name": "Roma",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0032.png",
            "vassalage": "FS"
        },
        {
            "id": 186183,
            "name": "sự giàu có vùng Caribe",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0046.png",
            "vassalage": "FS"
        },
        {
            "id": 182539,
            "name": "Thần Tài Sung Túc",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0029.png",
            "vassalage": "FS"
        },
        {
            "id": 182547,
            "name": "Quay Và Thắng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0037.png",
            "vassalage": "FS"
        },
        {
            "id": 193533,
            "name": "Apollo Quyền Năng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0057.png",
            "vassalage": "FS"
        },
        {
            "id": 193422,
            "name": "Nông Trại May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0056.png",
            "vassalage": "FS"
        },
        {
            "id": 193317,
            "name": "Lưỡi Gươm May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0055.png",
            "vassalage": "FS"
        },
        {
            "id": 193316,
            "name": "Kho báu Rắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0054.png",
            "vassalage": "FS"
        },
        {
            "id": 193276,
            "name": "Tứ đại Thần Thú may mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0052.png",
            "vassalage": "FS"
        },
        {
            "id": 193275,
            "name": "Đập tan người ngoài hành tinh",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0053.png",
            "vassalage": "FS"
        },
        {
            "id": 191617,
            "name": "Đường Đến Bài Cào",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/VI/FS0050.png",
            "vassalage": "FS"
        },
        {
            "id": 189679,
            "name": "Người Bảo Vệ Bảo Tàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/VI/FS0049.png",
            "vassalage": "FS"
        },
        {
            "id": 182553,
            "name": "Người Tuyết Yeti",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0043.png",
            "vassalage": "FS"
        },
        {
            "id": 182551,
            "name": "Vegas Quyến Rũ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0041.png",
            "vassalage": "FS"
        },
        {
            "id": 182548,
            "name": "Hạnh Phúc Nhân Ba",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0038.png",
            "vassalage": "FS"
        },
        {
            "id": 182546,
            "name": "Game Kẹo Nổ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0036.png",
            "vassalage": "FS"
        },
        {
            "id": 182545,
            "name": "Chinh Phục Vũ Trụ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0035.png",
            "vassalage": "FS"
        },
        {
            "id": 182544,
            "name": "Thảo Nguyên Chớp",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0034.png",
            "vassalage": "FS"
        },
        {
            "id": 182540,
            "name": "Ngôi Nhà Vương Giả",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0030.png",
            "vassalage": "FS"
        },
        {
            "id": 182538,
            "name": "Bài Poker",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0028.png",
            "vassalage": "FS"
        },
        {
            "id": 182537,
            "name": "Giai Điệu Đại Dương",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0027.png",
            "vassalage": "FS"
        },
        {
            "id": 182535,
            "name": "Ảo Tưởng Neon",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0025.png",
            "vassalage": "FS"
        },
        {
            "id": 182534,
            "name": "Võ Sĩ Muay Thái",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0024.png",
            "vassalage": "FS"
        },
        {
            "id": 182533,
            "name": "Số 7 Huyền Thoại",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0023.png",
            "vassalage": "FS"
        },
        {
            "id": 182532,
            "name": "Thần Thoại Maya",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0022.png",
            "vassalage": "FS"
        },
        {
            "id": 182531,
            "name": "Đế Chế Tiền Bạc",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0021.png",
            "vassalage": "FS"
        },
        {
            "id": 182530,
            "name": "Nấm Tặc Phiêu Lưu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0020.png",
            "vassalage": "FS"
        },
        {
            "id": 182529,
            "name": "Bonanza Khai Thác Vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0019.png",
            "vassalage": "FS"
        },
        {
            "id": 182528,
            "name": "Loki",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0018.png",
            "vassalage": "FS"
        },
        {
            "id": 182527,
            "name": "Huyền Thoại Nian",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0017.png",
            "vassalage": "FS"
        },
        {
            "id": 182526,
            "name": "Vận May",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0016.png",
            "vassalage": "FS"
        },
        {
            "id": 182525,
            "name": "Truyền Thuyết Đại Bàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0015.png",
            "vassalage": "FS"
        },
        {
            "id": 182524,
            "name": "Yêu Tinh May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0014.png",
            "vassalage": "FS"
        },
        {
            "id": 182523,
            "name": "Bẫy Ngọt Ngào",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0013.png",
            "vassalage": "FS"
        },
        {
            "id": 182522,
            "name": "Vận May Từ Trời 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0012.png",
            "vassalage": "FS"
        },
        {
            "id": 182521,
            "name": "Vận May Từ Trời",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0011.png",
            "vassalage": "FS"
        },
        {
            "id": 182520,
            "name": "Thần Tài",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0010.png",
            "vassalage": "FS"
        },
        {
            "id": 182519,
            "name": "Safari Tuyệt Vời",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0009.png",
            "vassalage": "FS"
        },
        {
            "id": 182518,
            "name": "Chàng Cao Bồi Săn Vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0008.png",
            "vassalage": "FS"
        },
        {
            "id": 182517,
            "name": "May Mắn Ganesha",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0007.png",
            "vassalage": "FS"
        },
        {
            "id": 182516,
            "name": "Nữ Hoàng Ai Cập",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0006.png",
            "vassalage": "FS"
        },
        {
            "id": 182515,
            "name": "Nối Trái Cây",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0005.png",
            "vassalage": "FS"
        },
        {
            "id": 182514,
            "name": "Sư Tử May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0004.png",
            "vassalage": "FS"
        },
        {
            "id": 182513,
            "name": "Dung Nham Cuồng Nhiệt",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0003.png",
            "vassalage": "FS"
        },
        {
            "id": 182512,
            "name": "Thành Phố Đá Quý",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/FS/EN/FS0002.png",
            "vassalage": "FS"
        }
    ],
    JDB: [
        {
            "id": 148172,
            "name": "Bát Kho Báu X-Huge",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB131.png",
            "vassalage": "JDB"
        },
        {
            "id": 11968,
            "name": "Siêu Bò B",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB069.png",
            "vassalage": "JDB"
        },
        {
            "id": 165188,
            "name": "Phiên Bản Siêu Super Deluxe",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB137.png",
            "vassalage": "JDB"
        },
        {
            "id": 170632,
            "name": "Blossom Of Wealth",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB167.png",
            "vassalage": "JDB"
        },
        {
            "id": 178152,
            "name": "Bonanza trái cây",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB189.png",
            "vassalage": "JDB"
        },
        {
            "id": 172427,
            "name": "Con át chủ bài",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB176.png",
            "vassalage": "JDB"
        },
        {
            "id": 186190,
            "name": "Rồng bay lên",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB217.png",
            "vassalage": "JDB"
        },
        {
            "id": 167134,
            "name": "Spindrift2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB148.png",
            "vassalage": "JDB"
        },
        {
            "id": 168128,
            "name": "Kông",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB153.png",
            "vassalage": "JDB"
        },
        {
            "id": 133278,
            "name": "Kho Báu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB112.png",
            "vassalage": "JDB"
        },
        {
            "id": 172466,
            "name": "Moneybag Man 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB177.png",
            "vassalage": "JDB"
        },
        {
            "id": 180226,
            "name": "Bùng Nổ Pháo Hoa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB203.png",
            "vassalage": "JDB"
        },
        {
            "id": 180742,
            "name": "Bàn thắng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB204.png",
            "vassalage": "JDB"
        },
        {
            "id": 179713,
            "name": "MỞ CỬA SESAME MEGA",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB201.png",
            "vassalage": "JDB"
        },
        {
            "id": 188154,
            "name": "Át Chủ Ma Thuật WILD LOCK",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB225.png",
            "vassalage": "JDB"
        },
        {
            "id": 180945,
            "name": "Cao thấp",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB205.png",
            "vassalage": "JDB"
        },
        {
            "id": 186191,
            "name": "Plinko",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB218.png",
            "vassalage": "JDB"
        },
        {
            "id": 179684,
            "name": "Đạp mìn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB199.png",
            "vassalage": "JDB"
        },
        {
            "id": 189485,
            "name": "Trang Sức May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB226.png",
            "vassalage": "JDB"
        },
        {
            "id": 190240,
            "name": "Kết Hợp Trái Cây Bonanza",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB228.png",
            "vassalage": "JDB"
        },
        {
            "id": 172183,
            "name": "Fortune Neko",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB175.png",
            "vassalage": "JDB"
        },
        {
            "id": 11935,
            "name": "Mở Vừng II",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB036.png",
            "vassalage": "JDB"
        },
        {
            "id": 169496,
            "name": "Maya Gold Crazy",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB162.png",
            "vassalage": "JDB"
        },
        {
            "id": 162506,
            "name": "Búa Thần Sấm",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB132.png",
            "vassalage": "JDB"
        },
        {
            "id": 174027,
            "name": "Lửa liên kết nguyên tố",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB181.png",
            "vassalage": "JDB"
        },
        {
            "id": 175516,
            "name": "CAISHEN COMING",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB185.png",
            "vassalage": "JDB"
        },
        {
            "id": 173837,
            "name": "Birds Party Deluxe",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB180.png",
            "vassalage": "JDB"
        },
        {
            "id": 170338,
            "name": "Big Three Dragons",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB165.png",
            "vassalage": "JDB"
        },
        {
            "id": 166139,
            "name": "Những Túi Tiền Đàn Ông",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB142.png",
            "vassalage": "JDB"
        },
        {
            "id": 11988,
            "name": "Đĩa Trái Cây Siêu Thú Vị",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB089.png",
            "vassalage": "JDB"
        },
        {
            "id": 11987,
            "name": "Truyền Thuyết Huaguoshan",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB088.png",
            "vassalage": "JDB"
        },
        {
            "id": 11986,
            "name": "Ông Trùm Bia",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB087.png",
            "vassalage": "JDB"
        },
        {
            "id": 11985,
            "name": "Chim Và Thú",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB086.png",
            "vassalage": "JDB"
        },
        {
            "id": 11984,
            "name": "Chúc Mừng Năm Mới",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB085.png",
            "vassalage": "JDB"
        },
        {
            "id": 11983,
            "name": "Mary Nhỏ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB084.png",
            "vassalage": "JDB"
        },
        {
            "id": 11977,
            "name": "Năm Phước Lành",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB078.png",
            "vassalage": "JDB"
        },
        {
            "id": 11969,
            "name": "Báo Cáo Dậu Vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB070.png",
            "vassalage": "JDB"
        },
        {
            "id": 11967,
            "name": "Múa Rồng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB068.png",
            "vassalage": "JDB"
        },
        {
            "id": 11966,
            "name": "Chó Làm Giàu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB067.png",
            "vassalage": "JDB"
        },
        {
            "id": 11963,
            "name": "Đông Thú",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB064.png",
            "vassalage": "JDB"
        },
        {
            "id": 11962,
            "name": "Chúc May Mắn 777",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB063.png",
            "vassalage": "JDB"
        },
        {
            "id": 11947,
            "name": "Rồng Bay",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB048.png",
            "vassalage": "JDB"
        },
        {
            "id": 11946,
            "name": "Anh Hùng Rồng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB047.png",
            "vassalage": "JDB"
        },
        {
            "id": 11944,
            "name": "Tỷ Phú",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB045.png",
            "vassalage": "JDB"
        },
        {
            "id": 11938,
            "name": "Chúc Mừng Cừu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB039.png",
            "vassalage": "JDB"
        },
        {
            "id": 11937,
            "name": "Làm Giàu Ngay Lập Tức",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB038.png",
            "vassalage": "JDB"
        },
        {
            "id": 11934,
            "name": "Thay Đổi Khuôn Mặt 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB035.png",
            "vassalage": "JDB"
        },
        {
            "id": 11932,
            "name": "Người Đẹp Giang Sơn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB033.png",
            "vassalage": "JDB"
        },
        {
            "id": 11917,
            "name": "Đền Olympia",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB018.png",
            "vassalage": "JDB"
        },
        {
            "id": 11916,
            "name": "Chim Sẻ Chim Sẻ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB017.png",
            "vassalage": "JDB"
        },
        {
            "id": 11915,
            "name": "Đế Chế Chuối Vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB016.png",
            "vassalage": "JDB"
        },
        {
            "id": 11914,
            "name": "Mở Cửa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB015.png",
            "vassalage": "JDB"
        },
        {
            "id": 11913,
            "name": "Bốn Báu Vật Học Tập",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB014.png",
            "vassalage": "JDB"
        },
        {
            "id": 11912,
            "name": "Napoléon",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB013.png",
            "vassalage": "JDB"
        },
        {
            "id": 11911,
            "name": "Năm Mới",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB012.png",
            "vassalage": "JDB"
        },
        {
            "id": 11909,
            "name": "Kho Báu Ánh Trăng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB010.png",
            "vassalage": "JDB"
        },
        {
            "id": 11902,
            "name": "Gấu Đen Đài Loan",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB003.png",
            "vassalage": "JDB"
        },
        {
            "id": 11901,
            "name": "Cuộc Phiêu Lưu Của Llama",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB002.png",
            "vassalage": "JDB"
        },
        {
            "id": 11900,
            "name": "Goku",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JDB/EN/JDB001.png",
            "vassalage": "JDB"
        }
    ],
    JILI: [
        {
            "id": 171099,
            "name": "Siêu Át",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0033.png",
            "vassalage": "JL"
        },
        {
            "id": 171110,
            "name": "Đế Quốc Hoàng Kim",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0044.png",
            "vassalage": "JL"
        },
        {
            "id": 171111,
            "name": "Ngọc May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0045.png",
            "vassalage": "JL"
        },
        {
            "id": 171087,
            "name": "Crazy777",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0021.png",
            "vassalage": "JL"
        },
        {
            "id": 171104,
            "name": "Quyền Vương",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0038.png",
            "vassalage": "JL"
        },
        {
            "id": 184930,
            "name": "Ngọc May Mắn 3",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0156.png",
            "vassalage": "JL"
        },
        {
            "id": 179115,
            "name": "Ngọc may mắn 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0125.png",
            "vassalage": "JL"
        },
        {
            "id": 171419,
            "name": "Thợ săn điên",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0046.png",
            "vassalage": "JL"
        },
        {
            "id": 185969,
            "name": "Siêu Ace Deluxe",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0162.png",
            "vassalage": "JL"
        },
        {
            "id": 174857,
            "name": "Át lớn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0093.png",
            "vassalage": "JL"
        },
        {
            "id": 174858,
            "name": "Ali Baba",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0094.png",
            "vassalage": "JL"
        },
        {
            "id": 190143,
            "name": "Xu May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0211.png",
            "vassalage": "JL"
        },
        {
            "id": 191580,
            "name": "Át chủ bài siêu cấp II",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0214.png",
            "vassalage": "JL"
        },
        {
            "id": 177721,
            "name": "Ace hoang dã",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0116.png",
            "vassalage": "JL"
        },
        {
            "id": 180387,
            "name": "Nữ Tư Tế Aztec",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0137.png",
            "vassalage": "JL"
        },
        {
            "id": 189029,
            "name": "Báo May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0189.png",
            "vassalage": "JL"
        },
        {
            "id": 186252,
            "name": "ba chú heo con",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0165.png",
            "vassalage": "JL"
        },
        {
            "id": 171102,
            "name": "Tiền Đang Đến",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0036.png",
            "vassalage": "JL"
        },
        {
            "id": 174166,
            "name": "JILI CAISHEN",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0083.png",
            "vassalage": "JL"
        },
        {
            "id": 171089,
            "name": "Bao Thanh Thiên",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0023.png",
            "vassalage": "JL"
        },
        {
            "id": 171088,
            "name": "Người đẹp bong bóng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0022.png",
            "vassalage": "JL"
        },
        {
            "id": 171078,
            "name": "Chin Shi Huang",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0012.png",
            "vassalage": "JL"
        },
        {
            "id": 171090,
            "name": "Điên cuồng FaFaFa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0024.png",
            "vassalage": "JL"
        },
        {
            "id": 180550,
            "name": "Khỉ may mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0139.png",
            "vassalage": "JL"
        },
        {
            "id": 184697,
            "name": "Ba đồng Thụy Long",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0154.png",
            "vassalage": "JL"
        },
        {
            "id": 171105,
            "name": "Kho báu bí mật",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0039.png",
            "vassalage": "JL"
        },
        {
            "id": 171094,
            "name": "Phong Thần",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0028.png",
            "vassalage": "JL"
        },
        {
            "id": 171106,
            "name": "Kho báu Pharaoh",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0040.png",
            "vassalage": "JL"
        },
        {
            "id": 175976,
            "name": "Joker vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0103.png",
            "vassalage": "JL"
        },
        {
            "id": 171097,
            "name": "Kho báu rồng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0031.png",
            "vassalage": "JL"
        },
        {
            "id": 186178,
            "name": "Tay súng điên 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0164.png",
            "vassalage": "JL"
        },
        {
            "id": 186721,
            "name": "Tiền điên đang đến để mở rộng đặt cược của bạn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0167.png",
            "vassalage": "JL"
        },
        {
            "id": 171098,
            "name": "Sạc trâu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0032.png",
            "vassalage": "JL"
        },
        {
            "id": 171095,
            "name": "Ngân hàng vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0029.png",
            "vassalage": "JL"
        },
        {
            "id": 171100,
            "name": "Nữ hoàng vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0034.png",
            "vassalage": "JL"
        },
        {
            "id": 194550,
            "name": "Điên Cuồng 777",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0233.png",
            "vassalage": "JL"
        },
        {
            "id": 194041,
            "name": "Vương Miện Lấp Lánh 40",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0229.png",
            "vassalage": "JL"
        },
        {
            "id": 194013,
            "name": "Hề Xiếc 4096",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0232.png",
            "vassalage": "JL"
        },
        {
            "id": 193709,
            "name": "Đế Chế Vàng 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0228.png",
            "vassalage": "JL"
        },
        {
            "id": 193546,
            "name": "Cô Nàng Bikini",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0227.png",
            "vassalage": "JL"
        },
        {
            "id": 193545,
            "name": "Mỏ Vàng Lớn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0226.png",
            "vassalage": "JL"
        },
        {
            "id": 193416,
            "name": "3 Chiếc Đèn Phù Thủy",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0224.png",
            "vassalage": "JL"
        },
        {
            "id": 193239,
            "name": "Đồng xu Cỏ ba lá 3x3",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0223.png",
            "vassalage": "JL"
        },
        {
            "id": 193238,
            "name": "Nồi Tiền Deluxe",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0222.png",
            "vassalage": "JL"
        },
        {
            "id": 193237,
            "name": "Nữ Hoàng Hải Tặc 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0221.png",
            "vassalage": "JL"
        },
        {
            "id": 193235,
            "name": "Kho Báu Vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0220.png",
            "vassalage": "JL"
        },
        {
            "id": 192690,
            "name": "Cú đá phạt đền",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0219.png",
            "vassalage": "JL"
        },
        {
            "id": 192689,
            "name": "Xu Hề",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0218.png",
            "vassalage": "JL"
        },
        {
            "id": 191598,
            "name": "10 Vương Miện Lấp Lánh",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0217.png",
            "vassalage": "JL"
        },
        {
            "id": 191585,
            "name": "Tiền điên 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0215.png",
            "vassalage": "JL"
        },
        {
            "id": 191562,
            "name": "3 con trâu xông pha",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0213.png",
            "vassalage": "JL"
        },
        {
            "id": 191557,
            "name": "Super Ace Joker",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0212.png",
            "vassalage": "JL"
        },
        {
            "id": 190078,
            "name": "Va Chạm Chạm Đích",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0210.png",
            "vassalage": "JL"
        },
        {
            "id": 189874,
            "name": "Roma X Cao Cấp",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0209.png",
            "vassalage": "JL"
        },
        {
            "id": 189823,
            "name": "3 Sư Tử May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0208.png",
            "vassalage": "JL"
        },
        {
            "id": 189822,
            "name": "Chiến Tranh Cricket",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0207.png",
            "vassalage": "JL"
        },
        {
            "id": 189821,
            "name": "3 Xu Ngựa Hoang",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0206.png",
            "vassalage": "JL"
        },
        {
            "id": 189759,
            "name": "Keno Cược Thêm",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0205.png",
            "vassalage": "JL"
        },
        {
            "id": 189622,
            "name": "Keno Cơ Hội Siêu Việt",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0204.png",
            "vassalage": "JL"
        },
        {
            "id": 189476,
            "name": "Nhiệm Vụ Truy Tìm Kho Báu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0203.png",
            "vassalage": "JL"
        },
        {
            "id": 189466,
            "name": "Cây Tiền Xu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0202.png",
            "vassalage": "JL"
        },
        {
            "id": 189349,
            "name": "Tiệc Kim Cương",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0200.png",
            "vassalage": "JL"
        },
        {
            "id": 189348,
            "name": "Trò Chơi Màu Sắc Cực Đỉnh",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0201.png",
            "vassalage": "JL"
        },
        {
            "id": 189347,
            "name": "Vẻ Đẹp Hawaii",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0199.png",
            "vassalage": "JL"
        },
        {
            "id": 189343,
            "name": "Cuộn Tiền Vô Tận Bùng Nổ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0198.png",
            "vassalage": "JL"
        },
        {
            "id": 189342,
            "name": "Bí ẩn Safari",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0197.png",
            "vassalage": "JL"
        },
        {
            "id": 189314,
            "name": "Cào Ngọc May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0195.png",
            "vassalage": "JL"
        },
        {
            "id": 189232,
            "name": "Tranh chức vô địch",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0194.png",
            "vassalage": "JL"
        },
        {
            "id": 189215,
            "name": "3 Kho Báu Xu 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0193.png",
            "vassalage": "JL"
        },
        {
            "id": 189213,
            "name": "Ngân Hàng Vàng 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0192.png",
            "vassalage": "JL"
        },
        {
            "id": 189112,
            "name": "Vua Thảo Nguyên",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0191.png",
            "vassalage": "JL"
        },
        {
            "id": 189051,
            "name": "Vòng Quay May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0190.png",
            "vassalage": "JL"
        },
        {
            "id": 188841,
            "name": "Săn Lùng Lúc Chạng Vạng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0187.png",
            "vassalage": "JL"
        },
        {
            "id": 188839,
            "name": "Cuộc Thi Quyền Anh Hoành Tráng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0185.png",
            "vassalage": "JL"
        },
        {
            "id": 188834,
            "name": "Tướng quân",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0184.png",
            "vassalage": "JL"
        },
        {
            "id": 188153,
            "name": "Nồi Tiền",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0182.png",
            "vassalage": "JL"
        },
        {
            "id": 188136,
            "name": "3 Rồng Nồi",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0180.png",
            "vassalage": "JL"
        },
        {
            "id": 188135,
            "name": "Chó May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0179.png",
            "vassalage": "JL"
        },
        {
            "id": 188091,
            "name": "Vòng quay trái cây",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0178.png",
            "vassalage": "JL"
        },
        {
            "id": 188010,
            "name": "Số thưởng Keno",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0177.png",
            "vassalage": "JL"
        },
        {
            "id": 188009,
            "name": "Poseidon",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0176.png",
            "vassalage": "JL"
        },
        {
            "id": 187830,
            "name": "Ánh Sáng của Ai Cập",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0174.png",
            "vassalage": "JL"
        },
        {
            "id": 187829,
            "name": "3 Chú Heo May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0173.png",
            "vassalage": "JL"
        },
        {
            "id": 186725,
            "name": "ngôi sao tiệc tùng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0171.png",
            "vassalage": "JL"
        },
        {
            "id": 186724,
            "name": "Crash Cricket",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0170.png",
            "vassalage": "JL"
        },
        {
            "id": 186722,
            "name": "Super Ace Scratch",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0168.png",
            "vassalage": "JL"
        },
        {
            "id": 186720,
            "name": "di sản Ai Cập",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0166.png",
            "vassalage": "JL"
        },
        {
            "id": 185984,
            "name": "Mục tiêu va chạm",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0163.png",
            "vassalage": "JL"
        },
        {
            "id": 185102,
            "name": "Phù Thủy Phép Thuật",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0161.png",
            "vassalage": "JL"
        },
        {
            "id": 185100,
            "name": "Tôm Cua Cá",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0160.png",
            "vassalage": "JL"
        },
        {
            "id": 184941,
            "name": "Trò chơi động vật",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0159.png",
            "vassalage": "JL"
        },
        {
            "id": 184940,
            "name": "Video Poker",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0158.png",
            "vassalage": "JL"
        },
        {
            "id": 184691,
            "name": "Joker độc đắc",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0153.png",
            "vassalage": "JL"
        },
        {
            "id": 184217,
            "name": "thần Zeus",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0152.png",
            "vassalage": "JL"
        },
        {
            "id": 183063,
            "name": "Thử Thách của Phượng Hoàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0151.png",
            "vassalage": "JL"
        },
        {
            "id": 183062,
            "name": "Lửa Quỷ 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0150.png",
            "vassalage": "JL"
        },
        {
            "id": 183028,
            "name": "Chiến binh đấu trường",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0149.png",
            "vassalage": "JL"
        },
        {
            "id": 182357,
            "name": "Phí Buffalo Ascent",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0148.png",
            "vassalage": "JL"
        },
        {
            "id": 181999,
            "name": "Đêm phù thủy",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0147.png",
            "vassalage": "JL"
        },
        {
            "id": 181926,
            "name": "Pearls of Bingo",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0146.png",
            "vassalage": "JL"
        },
        {
            "id": 181635,
            "name": "Vua Arthur",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0145.png",
            "vassalage": "JL"
        },
        {
            "id": 181610,
            "name": "Thành phố đêm",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0144.png",
            "vassalage": "JL"
        },
        {
            "id": 181505,
            "name": "Thành phố Tội lỗi",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0142.png",
            "vassalage": "JL"
        },
        {
            "id": 181110,
            "name": "Dabanggg",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0140.png",
            "vassalage": "JL"
        },
        {
            "id": 180389,
            "name": "lửa quỷ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0138.png",
            "vassalage": "JL"
        },
        {
            "id": 180267,
            "name": "Người đẹp Bangla",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0134.png",
            "vassalage": "JL"
        },
        {
            "id": 180141,
            "name": "Bingo Đèn Thần",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0132.png",
            "vassalage": "JL"
        },
        {
            "id": 179804,
            "name": "Cricket Sah 75",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0131.png",
            "vassalage": "JL"
        },
        {
            "id": 179741,
            "name": "Dự Đoán Màu Sắc",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0130.png",
            "vassalage": "JL"
        },
        {
            "id": 179438,
            "name": "Plinko",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0128.png",
            "vassalage": "JL"
        },
        {
            "id": 179303,
            "name": "Tiền thưởng tai nạn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0127.png",
            "vassalage": "JL"
        },
        {
            "id": 179279,
            "name": "Cricket King 18",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0126.png",
            "vassalage": "JL"
        },
        {
            "id": 179102,
            "name": "ngôi đền vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0124.png",
            "vassalage": "JL"
        },
        {
            "id": 178986,
            "name": "yêu tinh Ailen",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0123.png",
            "vassalage": "JL"
        },
        {
            "id": 178371,
            "name": "Keno",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0122.png",
            "vassalage": "JL"
        },
        {
            "id": 178067,
            "name": "mỏ vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0119.png",
            "vassalage": "JL"
        },
        {
            "id": 178045,
            "name": "Bánh xe",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0118.png",
            "vassalage": "JL"
        },
        {
            "id": 177965,
            "name": "Mật Địa Hoàng Kim",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0117.png",
            "vassalage": "JL"
        },
        {
            "id": 177720,
            "name": "lấp lửng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0115.png",
            "vassalage": "JL"
        },
        {
            "id": 177692,
            "name": "Bingo Adventure",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0114.png",
            "vassalage": "JL"
        },
        {
            "id": 177177,
            "name": "Vùng đất ngọt ngào",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0113.png",
            "vassalage": "JL"
        },
        {
            "id": 176841,
            "name": "xin chào",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0112.png",
            "vassalage": "JL"
        },
        {
            "id": 176795,
            "name": "mỏ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0110.png",
            "vassalage": "JL"
        },
        {
            "id": 176784,
            "name": "Tòa tháp",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0109.png",
            "vassalage": "JL"
        },
        {
            "id": 176203,
            "name": "Hổ chủ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0107.png",
            "vassalage": "JL"
        },
        {
            "id": 176197,
            "name": "nữ hoàng hải tặc",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0106.png",
            "vassalage": "JL"
        },
        {
            "id": 176189,
            "name": "PAPPU",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0105.png",
            "vassalage": "JL"
        },
        {
            "id": 176188,
            "name": "West Hunter Bingo",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0104.png",
            "vassalage": "JL"
        },
        {
            "id": 175673,
            "name": "tay đua hoang dã",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0102.png",
            "vassalage": "JL"
        },
        {
            "id": 175296,
            "name": "Mèo Thần Tài",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0101.png",
            "vassalage": "JL"
        },
        {
            "id": 175215,
            "name": "TwinWins",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0100.png",
            "vassalage": "JL"
        },
        {
            "id": 175214,
            "name": "Aladin",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0099.png",
            "vassalage": "JL"
        },
        {
            "id": 175213,
            "name": "Đêm Party",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0098.png",
            "vassalage": "JL"
        },
        {
            "id": 175212,
            "name": "Đặc vụ Át Chủ Bài",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0097.png",
            "vassalage": "JL"
        },
        {
            "id": 175199,
            "name": "Calaca Bingo",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0096.png",
            "vassalage": "JL"
        },
        {
            "id": 174883,
            "name": "Lễ hội Samba",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0095.png",
            "vassalage": "JL"
        },
        {
            "id": 174644,
            "name": "Cúp thế giới",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0090.png",
            "vassalage": "JL"
        },
        {
            "id": 174460,
            "name": "Chơi Bingo Mục tiêu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0089.png",
            "vassalage": "JL"
        },
        {
            "id": 174439,
            "name": "Jackpot Bingo",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0088.png",
            "vassalage": "JL"
        },
        {
            "id": 174438,
            "name": "Trò chơi màu sắc",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0087.png",
            "vassalage": "JL"
        },
        {
            "id": 174373,
            "name": "Giành chiến thắng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0086.png",
            "vassalage": "JL"
        },
        {
            "id": 174332,
            "name": "Thợ săn tiền thưởng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0085.png",
            "vassalage": "JL"
        },
        {
            "id": 174267,
            "name": "Bingo may mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0084.png",
            "vassalage": "JL"
        },
        {
            "id": 173953,
            "name": "Bingo Carnaval",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0074.png",
            "vassalage": "JL"
        },
        {
            "id": 173952,
            "name": "Super Bingo",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0073.png",
            "vassalage": "JL"
        },
        {
            "id": 173950,
            "name": "Fortune Bingo",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0071.png",
            "vassalage": "JL"
        },
        {
            "id": 173938,
            "name": "Irich Bingo",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0058.png",
            "vassalage": "JL"
        },
        {
            "id": 173834,
            "name": "Bone Fortune",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0057.png",
            "vassalage": "JL"
        },
        {
            "id": 173640,
            "name": "Crazy Pusher",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0056.png",
            "vassalage": "JL"
        },
        {
            "id": 172682,
            "name": "Đế chế Maya",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0055.png",
            "vassalage": "JL"
        },
        {
            "id": 172514,
            "name": "Tìm vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0054.png",
            "vassalage": "JL"
        },
        {
            "id": 172499,
            "name": "Happy Taxi",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0053.png",
            "vassalage": "JL"
        },
        {
            "id": 172468,
            "name": "Thor X",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0051.png",
            "vassalage": "JL"
        },
        {
            "id": 172250,
            "name": "Quyển sách hoàng kim",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0048.png",
            "vassalage": "JL"
        },
        {
            "id": 172129,
            "name": "Medusa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0047.png",
            "vassalage": "JL"
        },
        {
            "id": 171109,
            "name": "RomaX",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0043.png",
            "vassalage": "JL"
        },
        {
            "id": 171108,
            "name": "Cực giàu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0042.png",
            "vassalage": "JL"
        },
        {
            "id": 171107,
            "name": "May mắn đến",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0041.png",
            "vassalage": "JL"
        },
        {
            "id": 171103,
            "name": "Vua rừng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0037.png",
            "vassalage": "JL"
        },
        {
            "id": 171101,
            "name": "Bữa tiệc của khỉ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0035.png",
            "vassalage": "JL"
        },
        {
            "id": 171096,
            "name": "Lucky Goldbricks",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0030.png",
            "vassalage": "JL"
        },
        {
            "id": 171093,
            "name": "Candy Baby",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0027.png",
            "vassalage": "JL"
        },
        {
            "id": 171092,
            "name": "Fortune Pig",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0026.png",
            "vassalage": "JL"
        },
        {
            "id": 171091,
            "name": "Xi Yang Yang",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0025.png",
            "vassalage": "JL"
        },
        {
            "id": 171086,
            "name": "Seven Seven Seven",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0020.png",
            "vassalage": "JL"
        },
        {
            "id": 171085,
            "name": "Quan Vân Trường",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0019.png",
            "vassalage": "JL"
        },
        {
            "id": 171084,
            "name": "Cực Tốc Phát Đại Tài",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0018.png",
            "vassalage": "JL"
        },
        {
            "id": 171083,
            "name": "Vẻ đẹp Thượng Hải",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0017.png",
            "vassalage": "JL"
        },
        {
            "id": 171082,
            "name": "Hyper Burst",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0016.png",
            "vassalage": "JL"
        },
        {
            "id": 171081,
            "name": "Quả cầu may mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0015.png",
            "vassalage": "JL"
        },
        {
            "id": 171080,
            "name": "Cây tài lộc",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0014.png",
            "vassalage": "JL"
        },
        {
            "id": 171079,
            "name": "War Of Dragons",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0013.png",
            "vassalage": "JL"
        },
        {
            "id": 171077,
            "name": "Ớt cay",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/JL/EN/JL0011.png",
            "vassalage": "JL"
        }
    ],
    PP: [
        {
            "id": 182017,
            "Name": "Thưởng Chiến Thắng Mahjong",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0662.png",
            "vassalage": "PP"
        },
        {
            "id": 166183,
            "Name": "Tiền tiền tiền",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0159.png",
            "vassalage": "PP"
        },
        {
            "id": 184704,
            "Name": "Cuộc đua Wukong",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/VI/PP0727.png",
            "vassalage": "PP"
        },
        {
            "id": 170642,
            "Name": "Công chúa ánh sao",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0240.png",
            "vassalage": "PP"
        },
        {
            "id": 184692,
            "Name": "Kẹo Blitz",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0725.png",
            "vassalage": "PP"
        },
        {
            "id": 188875,
            "Name": "Tiệc Ma Cà Rồng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/VI/PP0855.png",
            "vassalage": "PP"
        },
        {
            "id": 183061,
            "Name": "Cổng lửa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0702.png",
            "vassalage": "PP"
        },
        {
            "id": 184644,
            "Name": "Đồng nội Megahays Megaways",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0722.png",
            "vassalage": "PP"
        },
        {
            "id": 183112,
            "Name": "Chúc may mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0710.png",
            "vassalage": "PP"
        },
        {
            "id": 183093,
            "Name": "Vụ Cướp Mạng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0708.png",
            "vassalage": "PP"
        },
        {
            "id": 9902,
            "Name": "Tê giác tuyệt vời",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0003.png",
            "vassalage": "PP"
        },
        {
            "id": 182363,
            "Name": "vận may Ace",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0671.png",
            "vassalage": "PP"
        },
        {
            "id": 169746,
            "Name": "Vua trâu Megaways",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0211.png",
            "vassalage": "PP"
        },
        {
            "id": 167648,
            "Name": "Bonanza vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0187.png",
            "vassalage": "PP"
        },
        {
            "id": 172469,
            "Name": "Fire Strike 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0320.png",
            "vassalage": "PP"
        },
        {
            "id": 185188,
            "Name": "Công Chúa Ánh Sao Pachi",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0738.png",
            "vassalage": "PP"
        },
        {
            "id": 167040,
            "Name": "Great Rhino Deluxe",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0171.png",
            "vassalage": "PP"
        },
        {
            "id": 166778,
            "Name": "Aztec Gems Deluxe",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0166.png",
            "vassalage": "PP"
        },
        {
            "id": 165939,
            "Name": "Great Rhino Megaways",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0135.png",
            "vassalage": "PP"
        },
        {
            "id": 193208,
            "Name": "Cổng Âm Phủ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1006.png",
            "vassalage": "PP"
        },
        {
            "id": 182941,
            "Name": "Đường Chạy 1000",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0696.png",
            "vassalage": "PP"
        },
        {
            "id": 192601,
            "Name": "Cổng Olympus Siêu Tán Xạ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/VI/PP0992.png",
            "vassalage": "PP"
        },
        {
            "id": 181486,
            "Name": "Cổng thiên đàng 1000",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0639.png",
            "vassalage": "PP"
        },
        {
            "id": 193282,
            "Name": "Mahjong Thắng Lớn Siêu Scatter",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1014.png",
            "vassalage": "PP"
        },
        {
            "id": 193257,
            "Name": "Olympus Chiến Thắng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1008.png",
            "vassalage": "PP"
        },
        {
            "id": 192728,
            "Name": "Chiến Thắng Ánh Sao",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0999.png",
            "vassalage": "PP"
        },
        {
            "id": 191599,
            "Name": "Phượng Hoàng May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/VI/PP0975.png",
            "vassalage": "PP"
        },
        {
            "id": 170367,
            "Name": "5 Lions Megaways",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0228.png",
            "vassalage": "PP"
        },
        {
            "id": 169859,
            "Name": "Cổng Olympus",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0218.png",
            "vassalage": "PP"
        },
        {
            "id": 175267,
            "Name": "5 Con Thỏ Megaways™",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0393.png",
            "vassalage": "PP"
        },
        {
            "id": 183059,
            "Name": "Sự trỗi dậy của Samurai 4",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0701.png",
            "vassalage": "PP"
        },
        {
            "id": 185265,
            "Name": "Sweet Bonanza 1000",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0739.png",
            "vassalage": "PP"
        },
        {
            "id": 182739,
            "Name": "Tàu tới Seoul",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0682.png",
            "vassalage": "PP"
        },
        {
            "id": 11844,
            "Name": "Bonanza ngọt ngào",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0086.png",
            "vassalage": "PP"
        },
        {
            "id": 178988,
            "Name": "Công chúa Ánh sáng 1000",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0555.png",
            "vassalage": "PP"
        },
        {
            "id": 173841,
            "Name": "Sugar Rush ™",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0349.png",
            "vassalage": "PP"
        },
        {
            "id": 180571,
            "Name": "Rujak Bonanza",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0618.png",
            "vassalage": "PP"
        },
        {
            "id": 9908,
            "Name": "Đá quý Aztec",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP0009.png",
            "vassalage": "PP"
        },
        {
            "id": 194549,
            "Name": "Ngọn Lửa Jackpot",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1057.png",
            "vassalage": "PP"
        },
        {
            "id": 194546,
            "Name": "Điều ước Huyền Bí",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1056.png",
            "vassalage": "PP"
        },
        {
            "id": 194545,
            "Name": "Cuồng Nộ Lửa 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1055.png",
            "vassalage": "PP"
        },
        {
            "id": 194544,
            "Name": "Bậc thầy thần chú",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1054.png",
            "vassalage": "PP"
        },
        {
            "id": 194543,
            "Name": "Tháp nhọn+",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1051.png",
            "vassalage": "PP"
        },
        {
            "id": 194282,
            "Name": "Bạc Hà Đá",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1048.png",
            "vassalage": "PP"
        },
        {
            "id": 194281,
            "Name": "Bộ Luật Cairo",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1047.png",
            "vassalage": "PP"
        },
        {
            "id": 194280,
            "Name": "Cá Chẽm Lớn Tái Xuất",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1046.png",
            "vassalage": "PP"
        },
        {
            "id": 194146,
            "Name": "Trường Học Xác Sống Megaways",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1043.png",
            "vassalage": "PP"
        },
        {
            "id": 194145,
            "Name": "Các anh hùng Argonaut",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1042.png",
            "vassalage": "PP"
        },
        {
            "id": 194143,
            "Name": "Sói Vàng 4 Gói",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1040.png",
            "vassalage": "PP"
        },
        {
            "id": 194142,
            "Name": "Khủng Long Rơi",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1039.png",
            "vassalage": "PP"
        },
        {
            "id": 194140,
            "Name": "Bộ ba đá quý",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1037.png",
            "vassalage": "PP"
        },
        {
            "id": 194139,
            "Name": "Bầu Cua Cá Cọp",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1036.png",
            "vassalage": "PP"
        },
        {
            "id": 194138,
            "Name": "Plinko may mắn+",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1035.png",
            "vassalage": "PP"
        },
        {
            "id": 194136,
            "Name": "Quay Cay Nóng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1033.png",
            "vassalage": "PP"
        },
        {
            "id": 194135,
            "Name": "Heo Tiết Kiệm Đảm Bảo Sinh Lời",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1032.png",
            "vassalage": "PP"
        },
        {
            "id": 194038,
            "Name": "777 Rush",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1030.png",
            "vassalage": "PP"
        },
        {
            "id": 193875,
            "Name": "Sweet Bonanza Siêu Tán Xạ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1029.png",
            "vassalage": "PP"
        },
        {
            "id": 193864,
            "Name": "Kẻ Xâm Lược Ngoài Hành Tinh",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1028.png",
            "vassalage": "PP"
        },
        {
            "id": 193863,
            "Name": "Câu Lạc Bộ Tropicana – Giờ Vui Vẻ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1027.png",
            "vassalage": "PP"
        },
        {
            "id": 193861,
            "Name": "Sóng Thần Poseidon",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1025.png",
            "vassalage": "PP"
        },
        {
            "id": 193860,
            "Name": "Kho Báu Lửa Đá Quý",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1024.png",
            "vassalage": "PP"
        },
        {
            "id": 193859,
            "Name": "Đá Quý Bậc Thầy",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1023.png",
            "vassalage": "PP"
        },
        {
            "id": 193858,
            "Name": "Vòng Quay Miễn Phí Ngon Tuyệt",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1022.png",
            "vassalage": "PP"
        },
        {
            "id": 193529,
            "Name": "Tiệc Vàng 2 Sau Giờ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1020.png",
            "vassalage": "PP"
        },
        {
            "id": 193423,
            "Name": "Người Bảo Vệ Đền Thờ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1019.png",
            "vassalage": "PP"
        },
        {
            "id": 193415,
            "Name": "Vòng Thưởng Đấm Bốc Cá Vược Khủng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1018.png",
            "vassalage": "PP"
        },
        {
            "id": 193283,
            "Name": "Vận May Của Người Aztec",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1015.png",
            "vassalage": "PP"
        },
        {
            "id": 193259,
            "Name": "Báu Vật Xác Ướp",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/PP/EN/PP1010.png",
            "vassalage": "PP"
        }
    ],
    SPADEGAMING: [
        {
            "id": 173836,
            "Name": "Di sản của Kong Maxways",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0145.png",
            "vassalage": "SG"
        },
        {
            "id": 176201,
            "Name": "Vegas quyến rũ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0153.png",
            "vassalage": "SG"
        },
        {
            "id": 171267,
            "Name": "Royal Katt",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0003.png",
            "vassalage": "SG"
        },
        {
            "id": 181636,
            "Name": "Nguyện vọng của Rồng thần",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0166.png",
            "vassalage": "SG"
        },
        {
            "id": 171603,
            "Name": "Nhà Royale",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0133.png",
            "vassalage": "SG"
        },
        {
            "id": 171878,
            "Name": "Fiery Sevens độc quyền",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0134.png",
            "vassalage": "SG"
        },
        {
            "id": 172151,
            "Name": "Con báo vàng Maxways",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0139.png",
            "vassalage": "SG"
        },
        {
            "id": 172034,
            "Name": "Caishen",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0137.png",
            "vassalage": "SG"
        },
        {
            "id": 180232,
            "Name": "Cuộc Chiến Siêu Mãnh Thú",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0162.png",
            "vassalage": "SG"
        },
        {
            "id": 171269,
            "Name": "Võ sĩ Muay Thái",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0005.png",
            "vassalage": "SG"
        },
        {
            "id": 175366,
            "Name": "Panda Opera",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0151.png",
            "vassalage": "SG"
        },
        {
            "id": 191554,
            "Name": "Thần Tài Mạt chược",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/VI/SG0180.png",
            "vassalage": "SG"
        },
        {
            "id": 171290,
            "Name": "888",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0026.png",
            "vassalage": "SG"
        },
        {
            "id": 178272,
            "Name": "Candy Bubble 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0157.png",
            "vassalage": "SG"
        },
        {
            "id": 171602,
            "Name": "Múa hổ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0132.png",
            "vassalage": "SG"
        },
        {
            "id": 171307,
            "Name": "Mối tình đầu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0043.png",
            "vassalage": "SG"
        },
        {
            "id": 171299,
            "Name": "Vương quốc anh em",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0035.png",
            "vassalage": "SG"
        },
        {
            "id": 175674,
            "Name": "Farmland Frenzy Maxway",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0152.png",
            "vassalage": "SG"
        },
        {
            "id": 193556,
            "Name": "Tỳ Hưu Vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0181.png",
            "vassalage": "SG"
        },
        {
            "id": 190372,
            "Name": "Bảy Rực Lửa Nóng 100",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/VI/SG0178.png",
            "vassalage": "SG"
        },
        {
            "id": 190371,
            "Name": "Bảy Rực Lửa Nóng 50",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/VI/SG0177.png",
            "vassalage": "SG"
        },
        {
            "id": 190370,
            "Name": "Bảy Rực Lửa Nóng 5",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/VI/SG0176.png",
            "vassalage": "SG"
        },
        {
            "id": 190369,
            "Name": "Giáng Sinh Hoang Dã",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/VI/SG0175.png",
            "vassalage": "SG"
        },
        {
            "id": 190368,
            "Name": "Ninja Trái Cây",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/VI/SG0174.png",
            "vassalage": "SG"
        },
        {
            "id": 190367,
            "Name": "Mèo Vui Vẻ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/VI/SG0173.png",
            "vassalage": "SG"
        },
        {
            "id": 189532,
            "Name": "Bánh xe Rắn May Mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0172.png",
            "vassalage": "SG"
        },
        {
            "id": 189442,
            "Name": "Đại DươngNgọc Trai",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/VI/SG0171.png",
            "vassalage": "SG"
        },
        {
            "id": 188808,
            "Name": "Cô Gái Viễn Tây",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/VI/SG0170.png",
            "vassalage": "SG"
        },
        {
            "id": 186844,
            "Name": "người đi trên sao",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0169.png",
            "vassalage": "SG"
        },
        {
            "id": 186843,
            "Name": "Con đường may mắn tối đa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0168.png",
            "vassalage": "SG"
        },
        {
            "id": 186833,
            "Name": "Sự phán xét của Chúa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0167.png",
            "vassalage": "SG"
        },
        {
            "id": 180884,
            "Name": "Kẹo Ngọt Kẹo Ngọt",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0164.png",
            "vassalage": "SG"
        },
        {
            "id": 180750,
            "Name": "Người bảo vệ thiên hà",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0163.png",
            "vassalage": "SG"
        },
        {
            "id": 179715,
            "Name": "Cuồng Về Moji",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0160.png",
            "vassalage": "SG"
        },
        {
            "id": 178985,
            "Name": "Săn Tìm Đá Quý",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0158.png",
            "vassalage": "SG"
        },
        {
            "id": 177699,
            "Name": "búa sấm sét",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0156.png",
            "vassalage": "SG"
        },
        {
            "id": 177690,
            "Name": "Rome",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/VI/SG0155.png",
            "vassalage": "SG"
        },
        {
            "id": 175257,
            "Name": "Caishen Deluxe Maxway",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0150.png",
            "vassalage": "SG"
        },
        {
            "id": 175256,
            "Name": "Sự Giàu Có Của Thỏ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/VI/SG0149.png",
            "vassalage": "SG"
        },
        {
            "id": 174874,
            "Name": "phép màu giáng sinh",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0148.png",
            "vassalage": "SG"
        },
        {
            "id": 174164,
            "Name": "Kỳ nghỉ Halloween",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0147.png",
            "vassalage": "SG"
        },
        {
            "id": 174123,
            "Name": "Cao bồi Gold Rush",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0146.png",
            "vassalage": "SG"
        },
        {
            "id": 173683,
            "Name": "Bữa tiệc đường",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0144.png",
            "vassalage": "SG"
        },
        {
            "id": 172635,
            "Name": "Thuyền trưởng Golds Fortune",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0143.png",
            "vassalage": "SG"
        },
        {
            "id": 172501,
            "Name": "Hành trình đến nơi hoang dã",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0142.png",
            "vassalage": "SG"
        },
        {
            "id": 172437,
            "Name": "Fruits Mania",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0140.png",
            "vassalage": "SG"
        },
        {
            "id": 172107,
            "Name": "Khám phá vũ trụ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0138.png",
            "vassalage": "SG"
        },
        {
            "id": 171880,
            "Name": "Jokers Treasure Exclusive",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0136.png",
            "vassalage": "SG"
        },
        {
            "id": 171879,
            "Name": "Lucky Koi độc quyền",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0135.png",
            "vassalage": "SG"
        },
        {
            "id": 171359,
            "Name": "Meo meo may mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0095.png",
            "vassalage": "SG"
        },
        {
            "id": 171358,
            "Name": "Cá voi vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0094.png",
            "vassalage": "SG"
        },
        {
            "id": 171355,
            "Name": "Da Fu Xiao Fu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0091.png",
            "vassalage": "SG"
        },
        {
            "id": 171350,
            "Name": "Phong thủy may mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0086.png",
            "vassalage": "SG"
        },
        {
            "id": 171349,
            "Name": "Highway Fortune",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0085.png",
            "vassalage": "SG"
        },
        {
            "id": 171346,
            "Name": "Fa Fa Fa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0082.png",
            "vassalage": "SG"
        },
        {
            "id": 171344,
            "Name": "Những ngôi sao tuyệt vời",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0080.png",
            "vassalage": "SG"
        },
        {
            "id": 171343,
            "Name": "Cổng Hoàng đế",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0079.png",
            "vassalage": "SG"
        },
        {
            "id": 171342,
            "Name": "Vàng rồng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0078.png",
            "vassalage": "SG"
        },
        {
            "id": 171341,
            "Name": "Sự thịnh vượng lớn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0077.png",
            "vassalage": "SG"
        },
        {
            "id": 171339,
            "Name": "5 vận may",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0075.png",
            "vassalage": "SG"
        },
        {
            "id": 171338,
            "Name": "Cá koi may mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0074.png",
            "vassalage": "SG"
        },
        {
            "id": 171336,
            "Name": "Đôi may mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0072.png",
            "vassalage": "SG"
        },
        {
            "id": 171335,
            "Name": "Cái Thần 888",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0071.png",
            "vassalage": "SG"
        },
        {
            "id": 171333,
            "Name": "5 Fortune dragons",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0069.png",
            "vassalage": "SG"
        },
        {
            "id": 171332,
            "Name": "Phiêu lưu Iceland",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0068.png",
            "vassalage": "SG"
        },
        {
            "id": 171331,
            "Name": "Pocket Mon Go",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0067.png",
            "vassalage": "SG"
        },
        {
            "id": 171328,
            "Name": "Vua Pharaoh",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0064.png",
            "vassalage": "SG"
        },
        {
            "id": 171327,
            "Name": "Bông sen vàng SE",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0063.png",
            "vassalage": "SG"
        },
        {
            "id": 171326,
            "Name": "Baby Cai Shen",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0062.png",
            "vassalage": "SG"
        },
        {
            "id": 171325,
            "Name": "168 vận may",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0061.png",
            "vassalage": "SG"
        },
        {
            "id": 171323,
            "Name": "Iceland SA",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0059.png",
            "vassalage": "SG"
        },
        {
            "id": 171322,
            "Name": "Great Stars SA",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0058.png",
            "vassalage": "SG"
        },
        {
            "id": 171320,
            "Name": "Rồng vàng SA",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0056.png",
            "vassalage": "SG"
        },
        {
            "id": 171319,
            "Name": "Big Prosperity SA",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0055.png",
            "vassalage": "SG"
        },
        {
            "id": 171318,
            "Name": "5 Fortune SA",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0054.png",
            "vassalage": "SG"
        },
        {
            "id": 171317,
            "Name": "Gà vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0053.png",
            "vassalage": "SG"
        },
        {
            "id": 171316,
            "Name": "Ho Yeah Monkey",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0052.png",
            "vassalage": "SG"
        },
        {
            "id": 171315,
            "Name": "Zeus",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0051.png",
            "vassalage": "SG"
        },
        {
            "id": 171313,
            "Name": "Chiến binh hổ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0049.png",
            "vassalage": "SG"
        },
        {
            "id": 171309,
            "Name": "Vua rừng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0045.png",
            "vassalage": "SG"
        },
        {
            "id": 171308,
            "Name": "Khỉ vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0044.png",
            "vassalage": "SG"
        },
        {
            "id": 171306,
            "Name": "Wow Thịnh vượng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0042.png",
            "vassalage": "SG"
        },
        {
            "id": 171305,
            "Name": "Công chúa Wang",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0041.png",
            "vassalage": "SG"
        },
        {
            "id": 171303,
            "Name": "FaFaFa2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0039.png",
            "vassalage": "SG"
        },
        {
            "id": 171301,
            "Name": "Kẹo pop",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0037.png",
            "vassalage": "SG"
        },
        {
            "id": 171300,
            "Name": "Vị thần thịnh vượng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0036.png",
            "vassalage": "SG"
        },
        {
            "id": 171298,
            "Name": "Mr Chu Tycoon",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0034.png",
            "vassalage": "SG"
        },
        {
            "id": 171297,
            "Name": "Con báo vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0033.png",
            "vassalage": "SG"
        },
        {
            "id": 171296,
            "Name": "Ba gấu trúc",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0032.png",
            "vassalage": "SG"
        },
        {
            "id": 171295,
            "Name": "Đèn huyền diệu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0031.png",
            "vassalage": "SG"
        },
        {
            "id": 171294,
            "Name": "Dancing Fever",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0030.png",
            "vassalage": "SG"
        },
        {
            "id": 171293,
            "Name": "Tiệm bánh ngọt",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0029.png",
            "vassalage": "SG"
        },
        {
            "id": 171292,
            "Name": "Anh hùng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0028.png",
            "vassalage": "SG"
        },
        {
            "id": 171291,
            "Name": "Ba ngôi sao may mắn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0027.png",
            "vassalage": "SG"
        },
        {
            "id": 171289,
            "Name": "Đế chế rồng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0025.png",
            "vassalage": "SG"
        },
        {
            "id": 171288,
            "Name": "Chuột tiền",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0024.png",
            "vassalage": "SG"
        },
        {
            "id": 171287,
            "Name": "Sách thần thoại",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0023.png",
            "vassalage": "SG"
        },
        {
            "id": 171286,
            "Name": "Wong Choy",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0022.png",
            "vassalage": "SG"
        },
        {
            "id": 171285,
            "Name": "Ngọn lửa đôi",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0021.png",
            "vassalage": "SG"
        },
        {
            "id": 171284,
            "Name": "Kho báu Jokers",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0020.png",
            "vassalage": "SG"
        },
        {
            "id": 171283,
            "Name": "Mega 7",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0019.png",
            "vassalage": "SG"
        },
        {
            "id": 171282,
            "Name": "Lò lửa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0018.png",
            "vassalage": "SG"
        },
        {
            "id": 171281,
            "Name": "Máy bay ném bom điên rồ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0017.png",
            "vassalage": "SG"
        },
        {
            "id": 171280,
            "Name": "Đá quý của người Maya",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0016.png",
            "vassalage": "SG"
        },
        {
            "id": 171279,
            "Name": "Sự trỗi dậy của người sói",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0015.png",
            "vassalage": "SG"
        },
        {
            "id": 171277,
            "Name": "Quái vật huyền thoại Saga",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0013.png",
            "vassalage": "SG"
        },
        {
            "id": 171276,
            "Name": "Hugon Quest",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0012.png",
            "vassalage": "SG"
        },
        {
            "id": 171274,
            "Name": "Đường Bonanza",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0010.png",
            "vassalage": "SG"
        },
        {
            "id": 171273,
            "Name": "Mèo ma thuật",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0009.png",
            "vassalage": "SG"
        },
        {
            "id": 171272,
            "Name": "Thần tượng tình yêu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0008.png",
            "vassalage": "SG"
        },
        {
            "id": 171270,
            "Name": "Cách chơi Poker",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0006.png",
            "vassalage": "SG"
        },
        {
            "id": 171268,
            "Name": "Rich Caishen",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0004.png",
            "vassalage": "SG"
        },
        {
            "id": 171266,
            "Name": "Wild Wet Win",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SG/EN/SG0002.png",
            "vassalage": "SG"
        }
    ],
    SPRIBE: [
        {
            "id": 179284,
            "Name": "Phi công",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SPB/EN/SPB002.png",
            "vassalage": "SPB"
        },
        {
            "id": 179289,
            "Name": "Hilo",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SPB/EN/SPB007.png",
            "vassalage": "SPB"
        },
        {
            "id": 179286,
            "Name": "Mục tiêu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SPB/EN/SPB004.png",
            "vassalage": "SPB"
        },
        {
            "id": 179288,
            "Name": "Minas",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SPB/EN/SPB006.png",
            "vassalage": "SPB"
        },
        {
            "id": 179287,
            "Name": "Plinko",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SPB/EN/SPB005.png",
            "vassalage": "SPB"
        },
        {
            "id": 179285,
            "Name": "Xúc xắc",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SPB/EN/SPB003.png",
            "vassalage": "SPB"
        },
        {
            "id": 179292,
            "Name": "Hotline",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SPB/EN/SPB010.png",
            "vassalage": "SPB"
        },
        {
            "id": 179290,
            "Name": "Keno",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SPB/EN/SPB008.png",
            "vassalage": "SPB"
        },
        {
            "id": 179291,
            "Name": "Mini Roulette",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/SPB/EN/SPB009.png",
            "vassalage": "SPB"
        }
    ],
    VA: [
        {
            "id": 189610,
            "Name": "Huyền thoại hoang dã",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0051.png",
            "vassalage": "VA"
        },
        {
            "id": 185551,
            "Name": "Tên Lửa Thần Tài",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0008.png",
            "vassalage": "VA"
        },
        {
            "id": 185556,
            "Name": "Wild Thần tài",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0013.png",
            "vassalage": "VA"
        },
        {
            "id": 189742,
            "Name": "Thần Tài Đa Năng 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0052.png",
            "vassalage": "VA"
        },
        {
            "id": 194033,
            "Name": "Mahjong Saga",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0062.png",
            "vassalage": "VA"
        },
        {
            "id": 185554,
            "Name": "Kho Báu Thần Long 3",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0011.png",
            "vassalage": "VA"
        },
        {
            "id": 189526,
            "Name": "Inca Zuma",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0049.png",
            "vassalage": "VA"
        },
        {
            "id": 193379,
            "Name": "Tự Rút Mạt Chược 4",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0055.png",
            "vassalage": "VA"
        },
        {
            "id": 189743,
            "Name": "Kho Báu Rồng Thiêng 4",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0053.png",
            "vassalage": "VA"
        },
        {
            "id": 185570,
            "Name": "Tự Rút Mạt Chược",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0027.png",
            "vassalage": "VA"
        },
        {
            "id": 185580,
            "Name": "Tự Rút Mạt Chược 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0037.png",
            "vassalage": "VA"
        },
        {
            "id": 188836,
            "Name": "Mạt chược Tự Bốc 3",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0047.png",
            "vassalage": "VA"
        },
        {
            "id": 194198,
            "Name": "Mèo Thần Tài",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0066.png",
            "vassalage": "VA"
        },
        {
            "id": 194197,
            "Name": "Pháo Hoa Phúc Lộc",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0065.png",
            "vassalage": "VA"
        },
        {
            "id": 194035,
            "Name": "Roman Gladiator",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0064.png",
            "vassalage": "VA"
        },
        {
            "id": 194034,
            "Name": "Lucky Gold Rush",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0063.png",
            "vassalage": "VA"
        },
        {
            "id": 194032,
            "Name": "KHO BÁU Tứ linh",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0061.png",
            "vassalage": "VA"
        },
        {
            "id": 194031,
            "Name": "Fortune Overflow",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0060.png",
            "vassalage": "VA"
        },
        {
            "id": 193383,
            "Name": "Piñata",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0059.png",
            "vassalage": "VA"
        },
        {
            "id": 193382,
            "Name": "Rồng Thần Bí",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0058.png",
            "vassalage": "VA"
        },
        {
            "id": 193381,
            "Name": "Thần Lửa Lò Rèn",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0057.png",
            "vassalage": "VA"
        },
        {
            "id": 193380,
            "Name": "Cuộc Đụng Độ Đêm Vĩnh Cửu",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0056.png",
            "vassalage": "VA"
        },
        {
            "id": 193378,
            "Name": "Khủng long dã",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/EN/VA0054.png",
            "vassalage": "VA"
        },
        {
            "id": 189222,
            "Name": "Chuyên gia khai thác",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0048.png",
            "vassalage": "VA"
        },
        {
            "id": 188835,
            "Name": "Đế chế vàng 2",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0046.png",
            "vassalage": "VA"
        },
        {
            "id": 185582,
            "Name": "Ba Thần Sao",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0039.png",
            "vassalage": "VA"
        },
        {
            "id": 185581,
            "Name": "Huyền thoại về Midas",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0038.png",
            "vassalage": "VA"
        },
        {
            "id": 185578,
            "Name": "Mở Cửa Phép Thuật",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0035.png",
            "vassalage": "VA"
        },
        {
            "id": 185577,
            "Name": "Ngọc Hội Thảo",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0034.png",
            "vassalage": "VA"
        },
        {
            "id": 185575,
            "Name": "Tần Thủy Hoàng PLUS",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0032.png",
            "vassalage": "VA"
        },
        {
            "id": 185574,
            "Name": "Robin Hood",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0031.png",
            "vassalage": "VA"
        },
        {
            "id": 185572,
            "Name": "Vương quốc Rồng Lửa",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0029.png",
            "vassalage": "VA"
        },
        {
            "id": 185571,
            "Name": "Nóng Ace",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0028.png",
            "vassalage": "VA"
        },
        {
            "id": 185567,
            "Name": "Đế Quốc Hoàng Kim",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0024.png",
            "vassalage": "VA"
        },
        {
            "id": 185566,
            "Name": "Đế Quốc Maya",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0023.png",
            "vassalage": "VA"
        },
        {
            "id": 185563,
            "Name": "Phượng Hoàng Truyền Kỳ",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0020.png",
            "vassalage": "VA"
        },
        {
            "id": 185559,
            "Name": "Đào Vàng",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0016.png",
            "vassalage": "VA"
        },
        {
            "id": 185558,
            "Name": "Xếp Kẹo Ngọt",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0015.png",
            "vassalage": "VA"
        },
        {
            "id": 185557,
            "Name": "Kho Báu Thần Long 3 M",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0014.png",
            "vassalage": "VA"
        },
        {
            "id": 185555,
            "Name": "Vua ớt",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0012.png",
            "vassalage": "VA"
        },
        {
            "id": 185550,
            "Name": "Tiền vào như nước",
            "showIcon": "https://images.484930494.com/TCG_GAME_ICONS/VA/VI/VA0007.png",
            "vassalage": "VA"
        }
    ]
  } as { [key: string]: any[] },

  // Lấy danh sách game theo sảnh
  async getTableList(typeGame: string) {
    await new Promise(resolve => setTimeout(resolve, 500)); // Delay giả lập
    const baseData = this.tableListData[typeGame] || [];
    
    // Thêm percent random cho mỗi game
    // 30% games có % trên 85, 70% games có % từ 1-85
    const data = baseData.map(item => {
      const isHighPercent = Math.random() < 0.3; // 30% chance
      const percent = isHighPercent 
        ? Math.floor(Math.random() * 10) + 86  // Random từ 86-95 (trên 85%)
        : Math.floor(Math.random() * 85) + 1;  // Random từ 1-85
      
      return {
        ...item,
        percent
      };
    });
    
    console.log(`🔧 Mock API: GET tableList for ${typeGame}`, data);
    return { data };
  }
};
